import { useMutation } from "@tanstack/react-query";
import { Button } from "@/components/ui/button";
import { createForeplayExpansionApi, isForeplayUsageUsable } from "./foreplay-expansion-api";

const api = createForeplayExpansionApi();

export function ForeplayProviderBalance() {
  const usage = useMutation({ mutationFn: () => api.usage() });
  const balance = usage.data;
  return (
    <section className="shrink-0 rounded border border-[#DCE3ED] p-3 text-xs text-[#526074]" data-testid="foreplay-provider-balance">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span>Check Foreplay credits before discovery or harvest. This check does not spend credits.</span>
        <Button size="sm" variant="outline" disabled={usage.isPending} onClick={() => usage.mutate()}>
          {usage.isPending ? "Checking provider balance…" : "Check provider balance"}
        </Button>
      </div>
      {usage.isPending ? null : usage.error instanceof Error ? (
        <p role="alert" className="mt-2 text-red-700">Could not check provider balance: {usage.error.message}</p>
      ) : balance ? (
        <div role="status" className="mt-2 space-y-1">
          <p>{balance.remainingCredits.toLocaleString()} provider credits remaining · {balance.reservedUnits.toLocaleString()} reserved · {balance.availableCredits.toLocaleString()} available</p>
          <p>Observed {new Date(balance.observedAt).toLocaleString()} · Valid until {new Date(balance.expiresAt).toLocaleString()}</p>
          <p>{isForeplayUsageUsable(balance) ? "Provider balance verified. Credits are checked again for each paid request." : balance.spendingBlockReason || "Spending is blocked or the balance has expired. Check again before proceeding."}</p>
        </div>
      ) : null}
    </section>
  );
}
